
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import MenuBookMenuItemTile from "../menu-book/menu-book-menu-item-tile.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog, MenuBookMenuItemTile },
  props: {
    dialog: false,
    orderInstructions: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      instruction: "",
      instructionRule: [(v) => !!v || "Instruction is required"]
    };
  },
  beforeMount() {
    this.instruction = this.orderInstructions;
  },
  computed: {
    ...mapState("order", ["cart", "restaurantDetails"]),
    ...mapGetters("order", ["getUnavailableItems"]),

    isAllItemsUnavailable() {
      return this.getUnavailableItems.length === this.cart.items.length;
    }
  },
  methods: {
    handleAddInstruction() {
      this.$emit("instruction-added", this.instruction);
    }
  }
};
